export const container = ({ width, withButtons }) => ({
    width,
    position: 'relative',

    paddingRight: withButtons ? '2rem' : 'unset',

    tabletLarge: {
        paddingLeft: withButtons ? '5rem' : 'unset',
        paddingRight: withButtons ? '5rem' : 'unset',
    },
});
